import React from "react";
import ReactDOM from "react-dom";
import LandingPage from "./components/LandingPage";
import "./index.css";

ReactDOM.render(<LandingPage />, document.getElementById("root"));
